<template>
  <b-card class="mt-1 mb-1">
    <b-row>
      <b-col md="4" class="mb-2">
        <b-form-group :label="$t('Search options')" label-for="search">
          <b-form-select v-model="selectedData" @change="updateGraph" class="w-100" id="search">
            <option :value="'nbMinutes'">{{ $t('Minutes Ordered') }}</option>
            <option :value="'nbFiles'">{{ $t('Files Ordered') }}</option>
            <option :value="'timeToDeliver'">{{ $t('Time to Deliver') }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="4" class="mb-3">
        <b-form-group :label="$t('Start Date')" label-for="input-start-date">
          <flat-pickr
            id="input-start-date"
            type="date"
            v-model="startDate"
            @input="updateGraph"
            class="form-control bg-white"
            :config="{ dateFormat: 'Y-m-d' }"
          ></flat-pickr>
        </b-form-group>
      </b-col>
      <b-col md="4" class="mb-3">
        <b-form-group :label="$t('End Date')" label-for="input-end-date">
          <flat-pickr
            id="input-end-date"
            type="date"
            v-model="endDate"
            @input="updateGraph"
            class="form-control bg-white"
            :config="{ dateFormat: 'Y-m-d' }"
          ></flat-pickr>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-checkbox v-model="showCaptioning" @change="updateGraph">{{ $t('Only Captioning') }}</b-form-checkbox>
        <b-form-checkbox v-model="showTranslation" @change="updateGraph">{{ $t('Only Translation') }}</b-form-checkbox>
      </b-col>
    </b-row>

    <div class="mt-3">
      <canvas ref="myChart"></canvas>
    </div>
  </b-card>
</template>

<script>
import {
  BFormSelect, BFormCheckbox, BRow, BCol, BCard, BFormGroup,
} from 'bootstrap-vue'
import Chart from 'chart.js'
import Apicall from '@/libs/api-call'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    BFormSelect,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    flatPickr,
  },
  props: {
    allUsers: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    allUsers() {
      this.updateGraph()
    },
  },
  data() {
    const today = new Date()
    const ninetyDaysAgo = new Date(today.setDate(today.getDate() - 90))

    return {
      selectedData: 'nbMinutes',
      startDate: ninetyDaysAgo.toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
      showCaptioning: false,
      showTranslation: false,
      myChart: null,
      chartData: null,
      dataFromApi: null,
      friendlyLabels: {
        nbMinutes: this.$t('Minutes Ordered'),
        nbFiles: this.$t('Files Ordered'),
        timeToDeliver: this.$t('Time to Deliver'),
      },
    }
  },
  mounted() {
    this.updateGraph()
  },
  methods: {
    async fetchData() {
      const api = new Apicall()
      let type = null
      if (this.showCaptioning) {
        type = 'CAPTIONING'
      } else if (this.showTranslation) {
        type = 'TRANSLATION'
      }
      const response = await api.getMinutesAndFilesOrderedByDay(this.startDate, this.endDate, this.allUsers, type, this.selectedData)
      this.dataFromApi = response.data.data
    },
    async updateGraph() {
      await this.fetchData()
      const labels = this.dataFromApi?.map(item => item.thedate)
      const finalData = this.dataFromApi?.map(item => item[this.selectedData])

      this.chartData = {
        labels,
        datasets: [{
          label: this.friendlyLabels[this.selectedData],
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
          data: finalData,
        }],
      }

      this.createChart()
    },
    createChart() {
      if (this.myChart) {
        this.myChart.destroy()
      }

      const ctx = this.$refs.myChart.getContext('2d')
      this.myChart = new Chart(ctx, {
        type: 'line',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                parser: 'YYYY-MM-DD',
                tooltipFormat: 'll',
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 20,
              },
              gridLines: {
                display: false,
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                display: false,
              },
              gridLines: {
                display: false,
                drawBorder: true,
                drawTicks: true,
              },
            }],
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true,
          },
        },
      })
    },

  },
}
</script>
